import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import { SessionBase } from '../session-base';
@Component({
  template: `
  <email-list class="wrapper-content"></email-list>
  `
})
export class SessionsEmailComponent extends SessionBase implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {
    super();
  }
  ngOnInit() {
    super.getSession(this.route.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/email/email.component.ts